module.exports = __webpack_public_path__ + "static/media/016.d4269fe3.jpg";